module.exports = __webpack_public_path__ + "img/comienzo.33a13dda.png";